var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelpCircleFill(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1z",
    fill: "#121318"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.709 13.769c-.012.255-.355.46-.609.434a3.978 3.978 0 00-.648-.007c-.3.022-.713-.23-.713-.532v-.224c0-1.328.91-1.746 1.776-2.104l.042-.018c.776-.321 1.51-.626 1.51-1.564 0-.88-.597-1.567-2.015-1.567-1.522 0-2.149.73-2.149 1.985a.239.239 0 01-.239.238H8.246a.343.343 0 01-.343-.343c0-2.283 1.373-3.567 4.18-3.567 2.775 0 4.014 1.463 4.014 3.15 0 1.79-1.03 2.328-1.94 2.745l-.11.05c-.7.321-1.31.6-1.338 1.324zM13.052 16.187c0 .94-.433 1.313-1.313 1.313-.955 0-1.314-.328-1.314-1.313 0-.97.448-1.299 1.314-1.299.865 0 1.313.328 1.313 1.299z",
    fill: "#fff"
  })));
}

export default SvgHelpCircleFill;